"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessTokenUsername = void 0;
const internals_1 = require("aws-amplify/adapter-core/internals");
const getAccessTokenUsername = (accessToken) => (0, internals_1.decodeJWT)(accessToken).payload.username;
exports.getAccessTokenUsername = getAccessTokenUsername;
